import makeStyles from '@mui/styles/makeStyles';
import { FullAddressForm } from 'components';
import React from 'react';
import { texts } from 'utils/languages/fr';
import { MemoizedButton } from '../memoized-components/MemoizedComponents';

const useStyles = makeStyles(theme => ({
    button: {
        marginBottom: 20,
    },
}));

const FiscalAddressForm = ({
    label,
    fiscalAddress,
    hasDifferentFiscalAddress,
    onChange,
    onToggle,
    errors,
    tunnelErrors,
}) => {
    const classes = useStyles();

    if (!fiscalAddress) {
        return null;
    }

    return (
        <React.Fragment>
            <MemoizedButton
                className={!hasDifferentFiscalAddress ? classes.button : ''}
                label={texts.FISCAL_ADDRESS_BUTTON}
                onClick={onToggle}
            />
            {hasDifferentFiscalAddress && (
                <FullAddressForm
                    label={label}
                    address={fiscalAddress}
                    onAddressChange={onChange}
                    errors={errors}
                    tunnelErrors={tunnelErrors}
                />
            )}
        </React.Fragment>
    );
};

export default FiscalAddressForm;
